import { render, staticRenderFns } from "./ACategoriaMoodleInscritos.vue?vue&type=template&id=047c5d00"
import script from "./ACategoriaMoodleInscritos.vue?vue&type=script&lang=js"
export * from "./ACategoriaMoodleInscritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports